export interface ExperienceEntry {
  hash: string;       // 8-char fake hex
  role: string;
  company: string;
  period: string;
  summary: string;
}

export const experienceData: ExperienceEntry[] = [
  {
    hash: "a3f10b2c",
    role: "Frontend Engineer",
    company: "Docsumo",
    period: "Apr 2023 – Present",
    summary:
      "Own core product features end-to-end on a React + TypeScript codebase: Entity Tables on AG Grid, real-time state for a visual workflow builder, and the migration to TypeScript.",
  },
  {
    hash: "7d4e9012",
    role: "Freelance Frontend Developer",
    company: "Upwork",
    period: "2021 – 2023",
    summary:
      "Shipped React and JavaScript apps end-to-end for international clients — scoping, responsive UIs, REST and Stripe integrations, and post-launch iteration.",
  },
  {
    hash: "1c8b55ad",
    role: "BSc. Computer Science",
    company: "Kathmandu University",
    period: "2018 – 2023",
    summary:
      "Executive member of the KU Computer Club: led seminars on React, Flutter, and Git for junior students.",
  },
];
